export default "__VITE_ASSET__BnUq26Qj__"